import React from "react"

export default () =>
    <ul style={{ listStyleType: "none" }}>
        <li><a href="/billy-brockmueller-invitational/records">Meet Records</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2026.pdf">2026</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2025.pdf">2025</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2024.pdf">2024</a></li>
        <li><a href="https://ri.milesplit.com/meets/526353-billy-brockmueller-invitational-2023/results#.ZATKJuzMIq0">2023</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2022.pdf">2022</a></li>
        <li><a href="https://tfrrs.org/results/63479/">2020</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2019.pdf">2019</a></li>
        <li><a href="/billy-brockmueller-invitational/results/2018.pdf">2018</a></li>
    </ul>
